const fromAnyToString = (any) => (any === null || undefined === any ? '' : String(any));

// noinspection JSUnusedGlobalSymbols
export default fromAnyToString;
